import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * Handles unsubscribing from subscriptions on destroy
 */
@Injectable()
export class SubscriberComponent implements OnDestroy {
  /** The subscriptions list */
  private subscriptions: Subscription[] = [];

  /** @inheritdoc */
  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  /**
   * Add a subscription
   * @param subscription The subscription
   */
  protected addSubscription(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }
}
